import React, { useState, Fragment } from "react";
import { supabase } from "../../../lib/supabaseClient";

const ForgotPassword = (props) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) {
      setError("Por favor ingresa tu correo electrónico.");
      return;
    }
    setLoading(true);
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: "https://www.listopago.com.co/recuperacion",
    });
    setLoading(false);
    if (resetError) {
      setError("No pudimos enviar el correo. Intenta de nuevo.");
      return;
    }
    setSuccess(true);
  };

  return (
    <Fragment>
      <div
        className={"wrapper__modal-wrap modal fade " + (props.modalForgotPassword ? "show" : "")}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="close__wrap pointer d-lg-none mx-auto" onClick={() => { setSuccess(false); setEmail(""); props.onCLickModalForgotPassword(); }}>
          <img src="./../images/sdd.png" alt="" />
        </div>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content position-relative">
            <div className="close__wrap pointer d-none d-lg-flex" onClick={() => { setSuccess(false); setEmail(""); props.onCLickModalForgotPassword(); }}>
              <img src="./../images/sdd.png" alt="" />
            </div>

            {success ? (
              <div className="text-center">
                <div className="text-center mb-3">
                  <img src="./../images/Group 24763.png" alt="" />
                </div>
                <h4 className="medium font__size--28 mt-3">¡Correo enviado!</h4>
                <p className="normal font__size--16 color__gray-1 mt-2 mb-4">
                  Revisa tu bandeja de entrada en <strong>{email}</strong> y sigue el enlace para restablecer tu contraseña.
                </p>
                <button
                  className="btn btn__purple shadow color__white w-100 font__size--14 medium rounded__12"
                  onClick={() => { setSuccess(false); setEmail(""); props.onCLickSwitchModal("login"); }}
                >
                  Volver al inicio de sesión
                </button>
              </div>
            ) : (
              <>
                <div className="text-center mb-4">
                  <div className="text-center">
                    <img src="./../images/Group 24763.png" alt="" />
                  </div>
                  <h4 className="medium font__size--32 text__32-1024 mt-3">Restablecer contraseña</h4>
                  <p className="normal font__size--16 text__16-1024 color__gray-1">Ingresa tu correo y te enviaremos un enlace</p>
                </div>

                {error && (
                  <div className="alert alert-danger font__size--14 py-2 mb-3" role="alert">
                    {error}
                  </div>
                )}

                <div className="form-group mb-4">
                  <label htmlFor="forgot-email" className="medium font__size--14 text__14-1024">Correo electrónico</label>
                  <div className="wrapper__field-wrap">
                    <input
                      id="forgot-email"
                      type="email"
                      className="form-control medium font__size--16 text__16-1024"
                      placeholder="Ingresa tu correo"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleReset(e)}
                    />
                  </div>
                </div>

                <button
                  className="btn btn__purple shadow color__white w-100 font__size--14 text__14-1024 medium rounded__12 position-relative z-2"
                  onClick={handleReset}
                  disabled={loading}
                >
                  {loading ? "Enviando..." : "Enviar enlace"}
                </button>

                <div className="mt-3 text-center medium font__size--14 text__14-1024">
                  <span className="color__purple pointer" onClick={() => props.onCLickSwitchModal("login")}>
                    Volver al inicio de sesión
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
